export interface IPolicyConstant
{
    Full: Number,
    Write: Number,
    Read: Number,
    None: Number
}
export const PolicyConstant:IPolicyConstant = {
    Full: 3,
    Write: 2,
    Read: 1,
    None: 4,
};
